import { render, staticRenderFns } from "./ApplicantForm.vue?vue&type=template&id=debbe924&scoped=true&"
import script from "./ApplicantForm.vue?vue&type=script&lang=js&"
export * from "./ApplicantForm.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantForm.vue?vue&type=style&index=0&id=debbe924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debbe924",
  null
  
)

export default component.exports